import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';

export enum FindingsDrawerQueryParams {
  SelectedFindingId = 'selectedFindingId',
  SelectedPolicyFindingId = 'selectedPolicyFindingId',
}

// Add here any new pages using drawers
export const DrawerRoutes = [RoutesStatesNamesEnum.findings];

export type DrawerQueryParams = FindingsDrawerQueryParams;
